import { render, staticRenderFns } from "./videoRecommend.vue?vue&type=template&id=7f0e395f&scoped=true"
import script from "./videoRecommend.vue?vue&type=script&lang=js"
export * from "./videoRecommend.vue?vue&type=script&lang=js"
import style0 from "./videoRecommend.vue?vue&type=style&index=0&id=7f0e395f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e395f",
  null
  
)

export default component.exports